module.exports = __webpack_public_path__ + "img/i_icon02.02810024.png";